function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.sort.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.date.to-iso-string.js";
import "core-js/modules/es6.string.trim.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.object.create.js";
import "core-js/modules/es6.object.get-prototype-of.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.set-prototype-of.js";
import "core-js/modules/es6.array.slice.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import { mapState } from 'vuex';
import { codemirror } from 'vue-codemirror';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import has from 'lodash/has';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { themesMixin } from '@/utils/themes';
import LineChartMixin from '@/components/core/dtwin/lineChartMixin';
import { relativeBreakpoint } from '../../../../utils/vuex';
import ApiService from '../../../../services/apiService';
import { calculateAxisValue } from '../../../../utils/charts';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
var CHART_BEGIN_ZERO = false;
var chartPreviewConfig = {
  legend: {
    display: false
  },
  scales: {
    yAxes: [{
      ticks: _objectSpread(_objectSpread({}, CHART_BEGIN_ZERO ? {
        suggestedMin: 0
      } : {}), {}, {
        fontSize: 8
      }),
      gridLines: {
        display: true
      }
    }],
    xAxes: [{
      type: 'time',
      distribution: 'series',
      time: {
        tooltipFormat: 'YYYY-MM-DD HH:mm',
        unit: 'day',
        displayFormats: {
          day: 'D.M.'
        }
      },
      ticks: {
        autoSkip: true,
        fontSize: 10
      },
      gridLines: {
        display: false
      }
    }]
  }
};
var cmOptionsDefaults = {
  mode: 'application/text',
  tabSize: 4,
  lineNumbers: false,
  line: true,
  lineWrapping: true,
  foldGutter: true,
  styleActiveLine: true,
  styleSelectedText: true,
  readOnly: true,
  hintOptions: {
    completeSingle: false
  },
  viewportMargin: Infinity
};
export default {
  name: 'CoreDtwinStatePreviewDbTiles',
  components: {
    codemirror: codemirror
  },
  mixins: [relativeBreakpoint, LineChartMixin, themesMixin],
  props: {
    twinDataStates: {
      type: Array,
      required: true
    },
    updatedStates: {
      type: Array,
      required: false,
      "default": function _default() {
        return [];
      }
    },
    favCard: {
      type: Boolean,
      required: false,
      "default": false
    },
    loading: {
      type: Boolean,
      required: false,
      "default": false
    },
    noDataAlert: {
      type: Boolean,
      required: false,
      "default": false
    },
    tileSizeSetting: {
      type: Number,
      required: false,
      "default": 0
    },
    chartDotRadius: {
      type: Number,
      required: false,
      "default": 2
    },
    overflow: {
      type: Boolean,
      required: false,
      "default": false
    },
    // only together with overflow
    maxHeight: {
      type: Number,
      required: false,
      "default": 450
    }
  },
  data: function data() {
    return {
      previewJsonData: null,
      previewStringData: null,
      showJsonDialog: false,
      showStringDialog: false,
      historyState: null,
      showHistoryDialog: false,
      cmOptionsJson: _objectSpread(_objectSpread({}, cmOptionsDefaults), {
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        mode: 'application/ld+json',
        lineWrapping: false
      }),
      cmOptionsString: _objectSpread(_objectSpread({}, cmOptionsDefaults), {
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        mode: 'application/text',
        lineWrapping: true
      }),
      chartDataFormated: {},
      chartLoading: false,
      multiChartConfig: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])), {}, {
    colsPerTile: function colsPerTile() {
      if (this.relativeBreakpoint.width > 1100) {
        return 3;
      }
      if (this.relativeBreakpoint.width > 800) {
        return 4;
      }
      if (this.relativeBreakpoint.width > 510) {
        return 6;
      }
      return 12;
    },
    boxStyle: function boxStyle() {
      var result = '';
      if (this.tileSizeSetting) {
        result = "".concat(result, "margin-left: 7px; margin-right: 7px;");
      }
      if (this.overflow) {
        result = "".concat(result, "max-height: ").concat(this.maxHeight, "px; overflow: auto;");
      }
      return result;
    },
    previewVisual: function previewVisual() {
      if (this.tileSizeSetting === 1) {
        return 'preview-tile-visual';
      }
      return 'preview-visual';
    },
    previewBatteryHeight: function previewBatteryHeight() {
      if (this.tileSizeSetting === 1) {
        return 83;
      }
      return 160;
    },
    previewAlertHeight: function previewAlertHeight() {
      if (this.tileSizeSetting === 1) {
        return 70;
      }
      return 140;
    },
    uiComponents: function uiComponents() {
      if (this.favCard && this.tileSizeSetting === 1) {
        return true; // FavCard and Big Tiles
      } else if (this.favCard && this.tileSizeSetting === 0) {
        return false; // FavCard and small Tiles
      } else if (!this.favCard && this.tileSizeSetting === 0) {
        return true; // No FavCard and D-Twin or other view
      }
      return true;
    },
    hasStateEditPermission: function hasStateEditPermission() {
      return (this.permissions || {})['DigitalTwin.manage'] || (this.permissions || {})['DigitalTwin.write'];
    },
    tiles: function tiles() {
      if (!this.twinDataStates) {
        return [];
      }
      var twinDataStates = [].concat(this.twinDataStates);
      twinDataStates.sort(function (a, b) {
        return a.properties.orderIdx - b.properties.orderIdx;
      });
      var sanitizedStates = [];
      for (var i = 0; i < twinDataStates.length; i++) {
        var state = twinDataStates[i];
        if (get(state, 'properties.valueType') === 'boolean') {
          // for each boolean state, add a button to toggle <--- that is the past
          // nowadays we jst show a nice colored icon and no possibility to toggle a button
          var modifierBoolTile = _objectSpread(_objectSpread({}, state), {}, {
            type: 'modifier-bool'
          });
          twinDataStates[i] = modifierBoolTile;
        }

        // Delete Geo-Coordnates if linked to DTWin Position or if visualisation-type is "hidden"
        if (!state.properties.linkGeoCoordinate && this.getComponentType(twinDataStates[i]) !== 'hidden') {
          if (!twinDataStates[i].properties.visual) {
            twinDataStates[i].properties.visual = {};
          }
          if (!twinDataStates[i].properties.visual.options) {
            twinDataStates[i].properties.visual.options = {};
          }
          if (twinDataStates[i].value === undefined) {
            twinDataStates[i].value = {};
          }
          sanitizedStates.push(twinDataStates[i]);
        }
      }
      return sanitizedStates;
    }
  }),
  watch: {
    updatedStates: function updatedStates() {
      var _this = this;
      if (this.historyState && this.updatedStates.findIndex(function (s) {
        return s.id === _this.historyState.id;
      }) >= 0) {
        if (this.$refs['dtwin-state-history']) {
          this.$refs['dtwin-state-history'].reloadData();
          this.filteredDashboardData(this.twinDataStates);
        }
      }
    },
    twinDataStates: function twinDataStates(updated, old) {
      if (!isEqual(updated, old)) {
        this.fetchChartData();
      }
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.fetchChartData();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    get: get,
    calculateAxisValue: calculateAxisValue,
    fetchChartData: function fetchChartData() {
      var _this3 = this;
      if (!this.twinDataStates) {
        return;
      }
      this.chartLoading = true;
      var promises = this.filteredDashboardData(this.twinDataStates).map(function (item) {
        _this3.setMultiConfigStateData(item);
        // MWa Debug console.log(item);
        return _this3.loadChartData(item);
      });
      return Promise.all(promises).then(function (results) {
        return results.map(function (item) {
          _this3.chartDataFormated[item.objModel.id] = _this3.formatMultipleData(item.objModel, item.responseData);
          // force-redraw the whole linechart component
          item.objModel.lineChartId = new Date().toISOString();
          return _this3.chartDataFormated[item.objModel.id];
        });
      }).then(function (data) {
        _this3.chartLoading = false;
        return data;
      })["catch"](function (err) {
        return console.error(err);
      });
    },
    getCompStyle: function getCompStyle(twinDataState) {
      if (this.getComponentType(twinDataState) === 'lineChart') {
        // IF tileSizeSetting is 1 then never show line charts with a span greater than 3
        if (this.tileSizeSetting === 1) {
          return {
            gridColumn: 'span 3'
          };
        }
        if (this.$vuetify.breakpoint.lgAndUp) {
          return {
            gridColumn: "span ".concat(this.getSpan(twinDataState))
          };
        }
        return {
          gridColumn: 'span 2'
        };
      }
      return {};
    },
    getComponentType: function getComponentType(state) {
      if (!state) {
        return null;
      }
      var typeState = get(state, 'properties.valueType');
      var typeReal = _typeof(get(state, 'value.value'));
      var typeVisual = get(state, 'properties.visual.type');

      // if a visual type was set via visual config then use that one
      if (typeVisual) {
        return typeVisual;
      }
      if (state.type === 'modifier-bool') {
        return 'modifier-bool';
      }
      if (typeState === 'button') {
        return 'button';
      }

      // if a the states type is json and real type is string or object than use json
      if (typeState === 'json' && (typeReal === 'string' || typeReal === 'object')) {
        return 'json';
      }

      // otherwise return based on the real type of the value or the states type
      // 'odometer' for numbers and 'string' to display everything else
      switch (typeReal || typeState) {
        case 'number':
          return 'fittext';
        default:
          return 'string';
      }
    },
    getSpan: function getSpan(state) {
      return Math.min(get(state, 'properties.visual.options.span'), 5) || 2;
    },
    getLowerBound: function getLowerBound(state, defaultValue) {
      if (state.properties.lowerBound === undefined) {
        return defaultValue;
      }
      return parseFloat(state.properties.lowerBound);
    },
    getUpperBound: function getUpperBound(state, defaultValue) {
      if (state.properties.upperBound === undefined) {
        return defaultValue;
      }
      return parseFloat(state.properties.upperBound);
    },
    getThresholds: function getThresholds(state, defaultMin, defaultMax) {
      var min = this.getLowerBound(state, defaultMin);
      var max = this.getUpperBound(state, defaultMax);
      return [min + (max - min) * 0.1, max - (max - min) * 0.5];
    },
    modifierBoolButtonColor: function modifierBoolButtonColor(boolSwitchData) {
      if (get(boolSwitchData, 'value.value') === true) {
        return this.color;
      }
      return undefined;
    },
    showJSON: function showJSON(a) {
      this.previewJsonData = this.outputValue(a);
      this.showJsonDialog = true;
    },
    showString: function showString(s) {
      this.previewStringData = String(s).trim();
      this.showStringDialog = true;
    },
    showHistory: function showHistory(a) {
      this.historyState = a;
      this.showHistoryDialog = true;
    },
    outputValue: function outputValue(item) {
      if (item === null) {
        return 'null';
      }
      try {
        var jsonObject = _typeof(item) === 'object' ? item : JSON.parse(item);
        // parse and then stringify again to get a nice format
        return JSON.stringify(jsonObject, null, 1);
      } catch (error) {
        // on error we return outside of try/catch
      }
      return item;
    },
    localizeDate: function localizeDate(a) {
      if (a) {
        moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
        if (this.tileSizeSetting === 0) {
          return moment(a).format('L LTS');
        }
        return moment(a).format('L');
      }
      return '-';
    },
    setMultiConfigStateData: function setMultiConfigStateData(objModel) {
      if (!isEmpty(objModel.properties.visual.options)) {
        var chartLinesCurved = has(objModel.properties.visual.options, 'chartLinesCurved') ? objModel.properties.visual.options.chartLinesCurved : true;
        var chartOmitNull = has(objModel.properties.visual.options, 'chartOmitNull') ? objModel.properties.visual.options.chartOmitNull : true;
        var start = moment(get(objModel, 'properties.visual.options.queryStartDate'));
        var end = moment(get(objModel, 'properties.visual.options.queryEndDate'));
        // We have to check whether to display days or hours in the xAxis ticks
        var differenceInDays = end.diff(start, 'days');
        var chartPreviewConfigVar = cloneDeep(chartPreviewConfig);
        // Display hours if we have a day or less
        if (differenceInDays <= 1) {
          chartPreviewConfigVar.scales.xAxes[0].time.unit = 'hour';
          chartPreviewConfigVar.scales.xAxes[0].displayFormats = {};
        }
        this.multiChartConfig[objModel.id] = _objectSpread(_objectSpread({}, chartLinesCurved ? _objectSpread(_objectSpread({}, chartPreviewConfigVar), {}, {
          elements: {
            line: {
              tension: 0.5
            },
            point: {
              pointStyle: 'circle',
              radius: this.chartDotRadius
            }
          }
        }) : _objectSpread(_objectSpread({}, chartPreviewConfigVar), {}, {
          elements: {
            line: {
              tension: 0
            }
          }
        })), chartOmitNull ? {} : {
          spanGaps: true
        });
      }
    },
    faIcon: function faIcon(dtItem) {
      return get(dtItem, 'value.value') ? get(dtItem, 'properties.visual.options.boolVisual.firstFaIcon') : get(dtItem, 'properties.visual.options.boolVisual.secondFaIcon');
    },
    faIconColor: function faIconColor(dtItem) {
      return get(dtItem, 'value.value') ? get(dtItem, 'properties.visual.options.boolVisual.firstColor') : get(dtItem, 'properties.visual.options.boolVisual.secondColor');
    },
    stateTitle: function stateTitle(dtItem) {
      return get(dtItem, 'value.value') ? get(dtItem, 'properties.visual.options.boolVisual.firstStateTitle') : get(dtItem, 'properties.visual.options.boolVisual.secondStateTitle');
    },
    isBooleanVisualisation: function isBooleanVisualisation(state) {
      return get(state, 'properties.valueType') === 'boolean' && !get(state, 'properties.visual.options.type') && get(state, 'properties.visual.options.boolVisual') !== undefined && get(state, 'properties.visual.options.boolVisual.firstStateTitle') !== '' && get(state, 'properties.visual.options.boolVisual.firstFaIcon') !== '' || get(state, 'properties.visual.options.boolVisual.secondStateTitle') !== '' && get(state, 'properties.visual.options.boolVisual.secondFaIcon') !== '';
    },
    modifierBoolButtonIcon: function modifierBoolButtonIcon(boolSwitchData) {
      if (get(boolSwitchData, 'value.value') === true || get(boolSwitchData, 'value.value') === 1) {
        return 'fal fa-toggle-on';
      }
      return 'fal fa-toggle-off';
    },
    modifierBoolButtonClicked: function modifierBoolButtonClicked(boolSwitchData) {
      boolSwitchData.value.value = !boolSwitchData.value.value;
      ApiService.digitalTwinUpdateStateValue(this, {
        id: boolSwitchData.id,
        dtwinId: boolSwitchData.dtwinId,
        value: get(boolSwitchData, 'value.value'),
        skipTransformer: true
      }).then(function () {
        // this.$emit('didUpdateStates', [boolSwitchData.id]);
      })["catch"](function (error) {
        console.error(error);
      });
    }
  }
};